import { ITonContractParams } from "../types/types.js";
import { scoreName } from "../config/config.js";
import { getContract } from "../contracts/getContract.js";

export const isScoreHolder = async ({
  address,
}: ITonContractParams): Promise<boolean> => {
  const { checkIsHolder } = getContract(address, scoreName);
  const isHolder = await checkIsHolder();

  return isHolder;
};
